import { render, staticRenderFns } from "./UploadForm.vue?vue&type=template&id=66b37ad5&scoped=true&"
import script from "./UploadForm.vue?vue&type=script&lang=js&"
export * from "./UploadForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66b37ad5",
  null
  
)

component.options.__file = "UploadForm.vue"
export default component.exports